module.exports = __webpack_public_path__ + "static/media/img_dance_10.9261a972.png";